import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'app/core/user/user.service';
import { UserRole } from 'app/core/user/user.types';

@Component({
  standalone: true,
  template: ''
})
export class SignedInRedirectComponent implements OnInit {
  private readonly _router = inject(Router);
  private readonly _userService = inject(UserService);

  ngOnInit(): void {
    const user = this._userService.currentUser();
    const target =
      user?.role === UserRole.WORKSHOP ? '/kanban' :
      user?.role === UserRole.SUPPORT ? '/users' :
      '/home';
    this._router.navigateByUrl(target, { replaceUrl: true });
  }
}
